import Stack from '@mui/material/Stack';
import React from 'react';
import Container from '@mui/material/Container';
import Typography from '@mui/material/Typography';

interface Props {
  data: CBanner;
}

const Banner: React.FC<Props> = ({ data }) => {
  return (
    <Stack
      sx={{
        background:
          'radial-gradient(circle, rgba(51,57,114,1) 0%, rgba(252,70,107,0) 40%),#060d20',
      }}
    >
      <Container sx={{ pt: 18, pb: 16 }}>
        <Stack
          justifyContent="center"
          fontSize={24}
          alignItems="center"
          sx={{
            mx: 'auto',
            textAlign: 'center',
            '&>p': { fontSize: { xs: 18, md: 24 } },
          }}
          spacing={2}
        >
          <Typography color="text.secondary" fontWeight={500}>
            {data?.subtitle}
          </Typography>
          <Typography
            color="text.primary"
            variant="h1"
            fontSize="9vw"
            sx={{
              background:
                'linear-gradient(135deg, hsla(0, 0%, 100%, 0) 56%, #e18e11 98%), linear-gradient(25deg, #0179bb 23%, #fff 60%)',
              WebkitBackgroundClip: 'text',
              WebkitTextFillColor: 'transparent',
            }}
          >
            {data?.title}
          </Typography>
          <Typography color="text.secondary" sx={{ width: { xs: 1, md: 0.6 } }}>
            {data?.description}
          </Typography>
        </Stack>
      </Container>
    </Stack>
  );
};

export default Banner;
